import { render, staticRenderFns } from "./Taxonomy.vue?vue&type=template&id=2741e0f0&scoped=true&"
import script from "./Taxonomy.vue?vue&type=script&lang=js&"
export * from "./Taxonomy.vue?vue&type=script&lang=js&"
import style0 from "./Taxonomy.vue?vue&type=style&index=0&id=2741e0f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2741e0f0",
  null
  
)

export default component.exports